import Vue from 'vue';
import VueRouter from 'vue-router';

// 导入组件
import Home from '@/views/user/home.vue';
import Search from '@/views/user/search.vue';
import positionDe from '@/views/user/positionDe.vue';
import communication from '@/views/communication.vue';
import corporation from '@/views/user/corporation.vue';
import policy from '@/views/policy.vue';
import curriculum from '@/views/user/curriculum.vue';
import companyDe from '@/views/user/companyDe.vue';
import records from '@/views/user/records.vue';
import policyDe from '@/views/policyDe.vue';
import explore from '@/views/company/explore.vue';
import deliver from '@/views/company/deliver.vue';
import poManage from '@/views/company/poManage.vue';
import postJob from '@/views/company/postJob.vue';
import resumeDe from '@/views/company/resumeDe.vue';
import myCenter from '@/views/company/myCenter.vue';
import companyHome from '@/views/company/companyHome.vue';
import interview from '@/views/company/interview.vue';
import policyAdmin from '@/views/company/policyAdmin.vue';
import policySubsidy from '@/views/company/policySubsidy.vue';
import setBusiness from '@/views/company/setBusiness.vue';
import addPolicy from '@/views/company/addPolicy.vue';
import dynamicDe from '@/views/dynamicDe.vue';
import dynamicList from '@/views/dynamicList.vue';
import policySearch from '@/views/policySearch.vue';
import declareRoad from '@/views/company/declareRoad.vue';
import aboutUs from '@/views/aboutUs.vue';
import agreement from '@/views/agreement.vue';
import appAgreement from '@/views/appAgreement.vue';

// 使用VueRouter插件
Vue.use(VueRouter);

// 定义路由
const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta:{
			title:'用户端首页'
		}
	},
	{
		path: '/aboutUs',
		name: 'aboutUs',
		component: aboutUs,
		meta:{
			title:'关于我们'
		}
	},
	{
		path: '/agreement',
		name: 'agreement',
		component: agreement,
		meta:{
			title:'用户协议'
		}
	},
	{
		path: '/appAgreement',
		name: 'appAgreement',
		component: appAgreement,
		meta:{
			title:'准聘用户协议'
		}
	},
	{
		path: '/search',
		name: 'Search',
		component: Search,
		meta:{
			title:'用户端搜索'
		}
	},
	{
		path: '/positionDe',
		name: 'positionDe',
		component: positionDe,
		meta:{
			title:'用户端职位详情'
		}
	},
	{
		path: '/communication',
		name: 'communication',
		component: communication,
		meta:{
			title:'聊天'
		}
	},
	{
		path: '/corporation',
		name: 'corporation',
		component: corporation,
		meta:{
			title:'搜索公司'
		}
	},
	{
		path: '/policy',
		name: 'policy',
		component: policy,
		meta:{
			title:'政策中心'
		}
	},{
		path: '/dynamicList',
		name: 'dynamicList',
		component: dynamicList,
		meta:{
			title:'公告/动态列表'
		}
	},{
		path: '/dynamicDe',
		name: 'dynamicDe',
		component: dynamicDe,
		meta:{
			title:'公告/动态详情'
		}
	},{
		path: '/policySearch',
		name: 'policySearch',
		component: policySearch,
		meta:{
			title:'政策搜索'
		}
	},
	{
		path: '/curriculum',
		name: 'curriculum',
		component: curriculum,
		meta:{
			title:'用户端简历'
		}
	},
	{
		path: '/companyDe',
		name: 'companyDe',
		component: companyDe,
		meta:{
			title:'用户端公司详情'
		}
	},
	{
		path: '/inCenter',
		name: 'inCenter',
		component: records,
		meta:{
			title:'用户端个人中心'
		}
	},
	{
		path: '/declare',
		name: 'declare',
		component: records,
		meta:{
			title:'用户端申报记录'
		}
	},
	{
		path: '/subsidy',
		name: 'subsidy',
		component: records,
		meta:{
			title:'用户端补贴记录'
		}
	}, {
		path: '/policyDe',
		name: 'policyDe',
		component: policyDe,
		meta:{
			title:'用户端政策详情'
		}
	}, {
		path: '/deliver',
		name: 'deliver',
		component: deliver,
		meta:{
			title:'投递管理'
		}
	},{
		path: '/fierce',
		name: 'fierce',
		component: explore,
		meta:{
			title:'公司端牛人'
		}
	},{
		path: '/poManage',
		name: 'poManage',
		component: poManage,
		meta:{
			title:'公司端职位管理'
		}
	},{
		path: '/postJob',
		name: 'postJob',
		component: postJob,
		meta:{
			title:'公司端发布职位'
		}
	},{
		path: '/resumeDe',
		name: 'resumeDe',
		component: resumeDe,
		meta:{
			title:'公司端简历详情'
		}
	},{
		path: '/myCenter',
		name: 'myCenter',
		component: myCenter,
		meta:{
			title:'公司端个人中心'
		}
	},{
		path: '/companyHome',
		name: 'companyHome',
		component: companyHome,
		meta:{
			title:'公司端公司主页'
		}
	},{
		path: '/interview',
		name: 'interview',
		component: interview,
		meta:{
			title:'公司端面试'
		}
	},{
		path: '/policyAdmin',
		name: 'policyAdmin',
		component: policyAdmin,
		meta:{
			title:'公司端政策管理'
		},
	},,{
		path: '/policySubsidy',
		name: 'policySubsidy',
		component: policySubsidy,
		meta:{
			title:'公司端政策补贴'
		},
	},{
		path: '/setBusiness',
		name: 'setBusiness',
		component: setBusiness,
		meta:{
			title:'公司端创建企业'
		}
	},{
		path: '/addPolicy',
		name: 'addPolicy',
		component: addPolicy,
		meta:{
			title:'公司端添加政策'
		}
	},{
		path: '/declareRoad',
		name: 'declareRoad',
		component: declareRoad,
		meta:{
			title:'公司端申报记录'
		}
	},
];

// 创建路由实例
const router = new VueRouter({
	mode: 'hash', // 使用HTML5 history模式，去掉URL中的#
	routes,
});

export default router;